import { envConfig } from '#constants/envConfig';

// Backend enrichment substitutes this placeholder when the actor has no uploaded
// avatar — treat it as "no avatar" so the ring falls back to the coloured initial.
const DEFAULT_AVATAR_FILENAME = 'default-avatar.png';

/**
 * WS call frames carry the actor avatar as a RAW storage path (`Euie/HQR.png`) —
 * unlike chat userData, which the gateway already resolves to a full URL. The
 * image loader passes non-absolute strings through untouched, so a raw path
 * renders as a broken (empty) avatar. Normalize: raw → MEDIA_URL/mh/user/…,
 * absolute URLs pass through, placeholder → null (initials fallback).
 */
export const toCallAvatarUrl = (path: string | null | undefined): string | null => {
  if (!path) return null;
  if (path.endsWith(DEFAULT_AVATAR_FILENAME)) return null;
  if (path.startsWith('http') || path.startsWith('/')) return path;
  return `${envConfig.MEDIA_URL}/mh/user/${path}`;
};
